import { render, staticRenderFns } from "./Comparative.vue?vue&type=template&id=7554296e&"
import script from "./Comparative.vue?vue&type=script&lang=js&"
export * from "./Comparative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports